import TemplateRegistry from '../template/template-registry';

// B2B Forms: email text
TemplateRegistry.templates['email'] = (option, config, onChange) => {

    // auto add email validation pattern
    if(!option.params.pattern){
        option.params.pattern = "[a-zA-Z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$";
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode#email
        option.params.inputmode = 'email';
    }

    return TemplateRegistry.templates['text'](option, config, onChange);
}